import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { i18n } from "@/setup/i18n-setup";
import { printLocalDate, printLocalDateTime } from "@/utils/pretty-print";

export class CalendarReminderNotification extends Notification {
	private getStartTimeText():string {
		if (!this.Data || !this.Data.StartTime) return "";
		let start = new Date(this.Data.StartTime);
		if (this.Data.AllDay) {
			return printLocalDate(start);
		}
		return printLocalDateTime(start);
	}

	private getTranslateData():any {
		return {
			...(this.Data || {}),
			start: this.getStartTimeText()
		};
	}

	getTitle():string {
		return i18n.t("common.notifications.title-calendar-reminder", this.getTranslateData()).toString();
	}

	getShortTitle():string {
		return i18n.t("common.short-notifications.title-calendar-reminder", this.getTranslateData()).toString();
	}

	getMessage():string {
		let key = this.isCrm() ? "message-calendar-reminder-crm" : "message-calendar-reminder";
		return i18n.t(`common.notifications.${key}`, this.getTranslateData()).toString();
	}

	isCrm():boolean {
		return !!(this.Data && this.Data.CrmID);
	}

	getRoute():string {
		if (this.isCrm()) {
			return `/crm/edit/${this.Data.CrmID}`;
		}
		return `/agenda?event=${this.Data?.EventID || 0}`;
	}

	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		return {
			routeTo: this.getRoute()
		};
	}

	public getIcon():string {
		return "bell";
	}

	public getTone():string {
		return "warning";
	}

	public getActionKey():string {
		return this.isCrm() ? "open-crm" : "open-agenda";
	}
}
